/**
 * @name useBoolValue
 * @param defaultValue {boolean as string} Example: 'true' || 'null'
 * @returns {boolean} Example: true || null
 */
function useBoolValue(defaultValue: string): boolean | null | undefined {
    const ValueToCheck = defaultValue.toLowerCase()
    switch (true) {
        case ValueToCheck === 'true':
            return true
        case ValueToCheck === 'false':
            return false
        case ValueToCheck === 'null':
            return null
        case ValueToCheck === 'undefined':
            return undefined
    }
}

export { useBoolValue }
